import React from 'react';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import AccountCircle from '@material-ui/icons/AccountCircle';
// import Share from '@material-ui/icons/Share';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/icons/Menu';
import Utils from '../../../Utils/Utils';
import Avatar from '@material-ui/core/Avatar';
import Mic from '@material-ui/icons/MicOutlined';
import Icon from '@material-ui/core/Icon';
import ScrollTo from '../../../Utils/ScrollTo';



class ButtonFiche extends React.Component {
  constructor(props) {
    super(props);
	const paddingX = 20;
	const paddingY = 10;
    this.state = {};
    this.styles = {
		button: {
			padding: 0,
			display: 'flex',
			flexWrap: 'nowrap',
			alignItems: 'stretch',
			border: '1px solid #dadada',
			boxShadow: 'none',
			outline: 'none',
			boxSizing: 'border-box',
			textTransform: 'uppercase',
			position: 'relative',
			color: '#000',
			borderRadius: '5px',
			cursor: 'pointer',
			backgroundColor: props.background,		
			overflow: 'hidden',
			fontWeight: '600'
		},
		text: {
			padding: `${paddingY}px ${paddingX}px`,
			fontSize: '9px',
			lineHeight: '12px',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		},
		icon: {
			background: '#fff',
			display: 'block',
			width: '40px',
			position: 'relative',
			marginLeft: '10px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		svg: {
			marginLeft: '-30%',
			width: '80%',
			height: '80%'
		},
		arrow: {
			display: 'block',
			position: 'absolute',
			top: '50%',
			right: '100%',
			border: '18px solid transparent',
			borderRightColor: '#fff',
			transform: 'translateY(-50%)',
		},
		bar: {
			display: 'block',
			width: '2px',
			position: 'absolute',
			top: `${paddingY/2}px`,
			bottom: `${paddingY/2}px`,
			zIndex: 2,
		},
		bar_left: {
			left: `${paddingX/2}px`,
			backgroundColor: '#fff',
		},
		bar_right: {
			right: `${paddingX/2}px`,
			backgroundColor: props.background			
		},
	};
  }

  render() {
    const { children } = this.props;
	console.log('this.props.background', this.props.background);
	//this.styles.button.backgroundColor = this.props.background;
	//this.styles.bar_right.backgroundColor = this.props.background;
    return (
      <button className="button-fiche" style={this.styles.button} >
        <span className="button-fiche__bar" style={{ ...this.styles.bar, ...this.styles.bar_left }}></span>
        <span className="button-fiche__text" style={this.styles.text}>{ window.FICHE_PROFIL || 'FICHE PROFIL'}</span>
        <span className="button-fiche__icon" style={this.styles.icon}>
          <svg width="24" height="24" strokeWidth="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={this.styles.svg}>
            <path d="M7 18V17C7 14.2386 9.23858 12 12 12V12C14.7614 12 17 14.2386 17 17V18" stroke="currentColor" strokeLineCap="round"/>
            <path d="M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z" stroke="currentColor" strokeLineCap="round" rokeLinejoin="round"/>
          </svg>
          <span className="button-fiche__arrow" style={this.styles.arrow}></span>
        </span>
        <span className="button-fiche__bar" style={{ ...this.styles.bar, ...this.styles.bar_right }}></span>
      </button>
    );
  }
}


const style = {
  selected: {
    backgroundColor: "turquoise !important",
    color: "white",
    fontWeight: 600
  }
};


let Share = ({ref, ...props}) => (<Icon style={{ border: "1px solid #dadada", borderRadius: "5px", padding: "4px", marginRight: "5px" }} {...props}>content_cut</Icon>);

export default class LiveChapter extends React.Component {

  colors = {
    text: window.theme.palette.background.txt || '#333333',
    background: window.theme.palette.background.paper,
    primary: window.theme.palette.primary.main,
    secondary: window.theme.palette.secondary.main,
  };
  
  
  state = {
    current: false,
    currentOdj: false,
    isDVR: false,
    isLive: false
  }

  progress = {
    backgroundColor: "#aaa",
    minWidth: '20px',
  };

  progressInner = {
    width: '0%',
    height: '100%',
    backgroundColor: this.colors.primary,
    transition: 'width 1000ms linear'
  };

  progressOdj = {
    float: 'left',
    width: '100%',
    height: '3px',
    backgroundColor: '#efefef',
    position: 'absolute',
    top: '0px',
    left: '0px'
  };
  
  chapterSpeaker = {
   width: '20px', 
   height: '20px',
   backgroundColor:'#ffffff',
   borderColor: Utils.hexToRGB(window.theme.palette.primary.main, 0.3),
  }
  
  chatperIndex = {
    backgroundColor: "#fff",
    borderColor:this.colors.text
  }
  
  chatperTitle = {
    color: this.colors.text,
    borderColor: this.colors.text,
    fontWeight: 500,
    //backgroundColor: Utils.hexToRGB(this.colors.text, 0.11),
  }
  
  chatperTitleMain = {
    color: this.colors.text,
    borderColor: this.colors.text,
    backgroundColor: Utils.hexToRGB(this.colors.text, 0.11),
    fontWeight: "bold",
    fontSize: "1rem",
    textTransform: "uppercase",
  }
  
  progressOdjInner = {
    width: '0%',
    height: '100%',
    backgroundColor: this.colors.text,
    transition: 'width 1000ms linear'
  };

  progressPieOdj = {
    backgroundColor: window.theme.palette.primary.light,
    animatioDelay: '-20s',
    display: 'none',
  }

  progressPieOdjInner = {
    backgroundColor: this.colors.text,
    transform: 'rotate(0deg)'
  }
  
  progressPieOdjHalf = {
    backgroundColor: this.colors.text
  }
  
  progressPieOdjInnerOver50 = {
    backgroundColor: this.colors.primary,
    transform: 'rotate(0deg)'
  }  
  
  pastille = {
    borderRadius: '5px',
    padding: '5px',
    backgroundColor: this.colors.primary,
    color: '#fff'
  }

  getCue() {
    if(this.props.speaker) {
      let cue = {
        duration: Math.round(this.props.chapter.duration),
        id: this.props.chapter.id,
        start_second: Math.round(this.props.chapter.live_second)
      }
      //console.log('cue', cue);
      return cue;
    }
    else {
      let cue = window.sdk.live.getCuepointById('chapter', this.props.chapter.id);
    
      //if(cue.duration == 0)
      //  cue.duration = window.sdk.live.getDurationOfCuepoint('chapter', this.props.chapter.id);
      //console.log('getCue', cue.duration);
      return cue;
    }
  }

  componentDidMount() {
    if (this.getCue()) {
      this.props.chapter.start_second = this.getCue().start_second;
      this.props.chapter.duration = this.getCue().duration;
   
      this.setState({
        isDVR: true
      })
    }
  }
  
  updateData() {
    console.log('my chapter is update')
    this.props.chapter.start_second = this.getCue().start_second;
    this.props.chapter.duration = this.getCue().duration;
    this.setState({
      isDVR: true
    })
  }

  seek = () => {
    if(!window.sdk.player().isDVR() && !window.sdk.player().isVOD()) {
      alert('Le DVR n\'est pas encore accessible il le sera dans quelques secondes');
      return;
    }
	    
    if(this.props.speaker) {
      window.sdk.player().seek(this.props.chapter.live_second);
    }
    else {
      if (this.getCue()) {
        window.sdk.player().seek(this.getCue().start_second);
      }
    }
	
	setTimeout(() => {
		try {
			let el = document.querySelector('.chapter-current');
			this.scroll = new ScrollTo(el.getAttribute('id'), 'tab_inner', true).go();
		}
		catch(err) {
			
		}
	}, 1000);
	
	/*setTimeout(() => {
		window.sdk.emit('seeked');
	}, 500);
	setTimeout(() => {
		window.sdk.emit('seeked');
	}, 1000);
	setTimeout(() => {
		window.sdk.emit('seeked');
	}, 1500);*/
  }

  setCurrentOdj(value) {
    this.setState({
      currentOdj: value
    });
    if (value) {
      this.showProgressOdj()
    }
    else {
      this.hideProgressOdj()
    }
  }

  showProgressOdj() {
    if (!this.intervalOdj) {
      let cue = this.getCue();
      if(cue.duration == 0) {
        if(this.props.speaker)
          cue.duration = 0;
        else
          cue.duration = window.sdk.live.getDurationOfCuepoint('chapter', cue.indexA);
      }
      this.intervalOdj = setInterval(() => {
        let time = window.sdk.player().dataTime.currentTime; //window.sdk.player().getCurrentTime();
        let e = (time - parseInt(cue.start_second));
        let percent = (e * 100) / parseInt(cue.duration);

        
        if (this.props.speaker) {
          let id = 'progressOdj-speaker';
          document.getElementById(id).style.width = Math.round(percent) + '%'
        } 
        else {
          document.getElementById('progress-chapter-odj').style.animationDelay = '-' + percent + 's';
        }
        
        // console.log('aniamtion delay "-' + percent + 's" - TIME: ', time, ' - START: ', cue.start_second, ' - DURATION: ', cue.duration)
      }, 1000);
    }
  }
  
  setCurrentLive(value) {
    console.log('my chapter is live', this.props.chapter);
    this.setState({
      isLive: value
    });
  }
  
  hideProgressOdj() {
    clearInterval(this.intervalOdj);
    this.intervalOdj = null;
  }
  
  showSpeaker = (e) => {
    console.log(e.screenX);
    
    window.entered = false;
    e.preventDefault();
    e.stopPropagation();
    window.sdk.emit('showSpeaker', {
      title: this.props.chapter.value.speaker.firstname + ' ' + this.props.chapter.value.speaker.lastname,
      description: this.props.chapter.value.speaker.organization,
      id: this.props.chapter.value.speaker.id,
      x: e.screenX,
      y: e.screenY,
      live: true
    });
    if(this.timeout)
      clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if(!window.entered)
        window.sdk.emit('hideSpeakerPopup');
    }, 2000)
  }
  
  share = (e, index) => {
	//alert(index);
    e.preventDefault();
    e.stopPropagation();
    window.sdk.emit('showExtract', {
      index: index
    });
  }

  render() {

    let style, subStyle = {};
    let subStyleOdj1 = {
      fontWeight: 400,
      color: this.colors.text,
    }
    let subStyleOdj2 = {
      color: Utils.hexToRGB(this.colors.text, 0.5),
      fontWeight: 500,
    }

    /*
    if (this.state.currentOdj) {
      style = {
        backgroundColor: window.theme.palette.primary.main,
        color: 'white'
      };
      subStyle = {
        color: 'white'
      }
      subStyleOdj1.color = 'white';
      subStyleOdj2.color = 'white';

    }
    */
    
    //window.sdk.player().addChapterExceededTime('exceeded-time-' + this.props.chapter.id, this.props.chapter.start_second);

    const existTitle = this.props.chapter && this.props.chapter.title;
	
	let chapterTitleCSS = JSON.parse(JSON.stringify(this.chatperTitle));
	if(this.state.currentOdj) {		
		chapterTitleCSS.color = this.colors.primary;
    }
	
    return (

        <ListItem id={ 'chapter-' + this.props.chapter.id } button={ this.state.isDVR } style={ style } selected={ this.state.currentOdj } classes={{ selected: 'chapter-current' }} className={ (this.props.speaker ? 'chapter_speaker_item ': '') + 'chapter-odj-' + this.props.chapter.id + ' ' + this.props.className } onClick={ this.seek }>
          { (this.props.num > 0  || this.props.speaker) && <div className="timeline-guide"></div> }
          
          {/*
            this.state.isLive && !window.sdk.player().isVOD() &&
              <Typography className="live_span">live</Typography>
          */}

          
          {(this.state.currentOdj && !this.props.speaker ) && 
            <style>{`
              .chapter-current-odj-${this.props.chapter.id} { background: #ccc; } 
              .chapter-current-odj-${this.props.chapter.id} .timeline-guide { border: none; border-left: 5px solid ${ this.colors.primary }; left: 27px; }
              .chapter-current-odj-${this.props.chapter.id} .chapter-index { margin-left: 5px; width: 14px; height: 14px; flex: 0 0 14px; }
            `}</style>}
          
          { this.props.speaker &&
            <Avatar  className={ 'chapter-speaker avatar--bg' } style={this.chapterSpeaker} aria-label="Recipe">
              <div className={ 'avatar__image' } style={{ backgroundImage: "url(https://secure.synople.tv/mediacenter3/speakers/" + this.props.chapter.value.speakerId + ".png)" }}  />
            </Avatar>
          }
          
          { this.props.speaker &&
            <ListItemText
              className="chapter-title-speaker"
              disableTypography
              style={ Object.assign({}, subStyleOdj1, window.sdk.isOverlay() ? { paddingRight: 5 } : {}) }
              primary={<Typography style={{ color: "inherit", fontWeight: "inherit" }}>{ this.props.chapter.value.speaker.firstname + ' ' + this.props.chapter.value.speaker.lastname }</Typography>}
              secondary={ <Typography style={ subStyleOdj2 }>{ this.props.chapter.description }</Typography> }
            />
          }
          
          { this.state.currentOdj && this.props.speaker && 
            <div style={ this.progress } id="progress-container">
              <span className="material-symbols-outlined">
                mic
              </span>
              <div id={"progressOdj" + (this.props.speaker ? '-speaker':'') } style={ this.progressInner }></div>
            </div>
          }
          
          { !this.props.speaker &&
          
            <ListItemText
              className="chapter-row"
              disableTypography
              primary={
                <Typography color={(this.state.isDVR ? 'secondary':'inherit')} className={"chapter-title-row"}>
                  <React.Fragment>
                    { this.props.num && <span className="chapter-index" style={ this.chatperIndex }>{ this.props.num }</span> }
                    { 
                      this.state.currentOdj && 
                      <span id="progress-chapter-odj" style={ this.progressPieOdj }></span>
                    }
                  </React.Fragment>
                  <span className="chapter-title" style={ chapterTitleCSS }>{ existTitle && this.props.chapter.title }{ (existTitle && this.props.chapter.description) && ' - '}{ this.props.chapter.description }</span>
                </Typography>
                
              }
              secondary={ <Typography style={ subStyleOdj2 }></Typography> }
            />
          }
          
          <div className="chapter-actions">
            { this.state.currentOdj &&
              <div onClick={ (e) => { this.share(e, this.props.chapter.id) }} className="speaker-card-btn" style={{ border: "0px solid transparent", padding: "4px", color: this.colors.primary }}>
                <span className="material-symbols-outlined ciseaux">
                  cut
                </span>
              </div>
            }

            { this.props.speaker && 
              <div onClick={ this.showSpeaker } className="speaker-card-btn" style={{ border: "0px solid transparent", padding: "4px", color: this.colors.primary }}>
                <span className="material-symbols-outlined">
                  badge
                </span>
              </div>
            }
          </div>
          
        </ListItem>
        
    
    );
  }

}



// WEBPACK FOOTER //
// ./src/Player/Tabs/Odj/LiveChapter.js